export const selectAvailableLanguages = state => state.language.available;

export const selectPreferredLanguage = state => state.language.preferred;

export const selectLocale = state => {
    const language = state.language.preferred.languageCodeIso2 || 'sv';
    const country = state.language.memberCountryCodeIso2 || 'SE';

    return `${language}-${country}`;
};

export const selectIsForeignLanguageActivated = state =>
    selectPreferredLanguage(state).languageCodeIso2 !== 'sv';
